import { render, staticRenderFns } from "./ComposerEdit.vue?vue&type=template&id=7bb92a51&"
import script from "./ComposerEdit.vue?vue&type=script&lang=js&"
export * from "./ComposerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports